import { isStorageWritable, Storage, useGlobalStorages } from '@features/storages'
import { useBotVariables } from '../../../store/flow'

export function useIsStorageWritable() {
  const botVariables = useBotVariables()
  const globalStorages = useGlobalStorages()

  return (storage: Storage | string | undefined | null) =>
    isStorageWritable(storage, botVariables, globalStorages)
}
